import { Link } from 'react-router-dom';
import './offers.css';
const Offers =()=>{
    return(
        <div className="Offers"><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
        <center>
<img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669015111/logo_2_vqa5nf.png" width="200" height="180" />
</center>
    <ul>
        <li><Link to="/"><b>HOME</b></Link></li>
        <li><Link to="/about"><b>ABOUT US</b></Link></li>
        <li><Link to="/menu"><b>MENU</b></Link></li>
        <li><Link to="/offers"><b>OFFERS</b></Link></li>
    </ul>
        <center><h1>OFFERS AND DEALS</h1></center><br></br>
    <button class="hi"><Link to="/menu"><b>Back to menu →</b></Link></button>
    <br></br>
    <br></br>
    <div className="cards">
        <div className="card1"><img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669023675/off3_rtrrjp.jpg" height="300" width="300"/>
            <center>
            <button className='btn'><Link to="/1">Redeem</Link></button>
            </center></div>

        <div className="card1"><img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669023674/BIGSAVE_zorcya.jpg" height="300" width="300"/>
            <center><button className='btn'><Link to="/2">Redeem</Link></button>
            </center></div>

        <div className="card1"><img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669023673/box_ojxozb.jpg" height="300" width="300"/>
            <center><button className='btn'><Link to="/3">Redeem</Link></button>
            </center></div>
    </div>

    <div class="cards">
        <div className="card1"><img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669023678/off2_rhorig.jpg" height="300" width="300"/> 
            <center><button className='btn'><Link to="/4">Redeem</Link></button>
            </center> </div>

        <div className="card1"><img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669023918/rsz_addchk99_q71szu.jpg" height="300" width="300"/> 
            <center><button className='btn'><Link to="/5">Redeem</Link></button>
            </center></div>

        <div className="card1"><img src="https://res.cloudinary.com/dggrpzdnl/image/upload/v1669023918/VEGZINGER_yvdiw7.jpg" height="300" width="300"/>
            <center><button className='btn'><Link to="/6">Redeem</Link></button>
            </center></div>
    </div>
    </div>
    )
};
export default Offers;